import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DxButtonModule,
  DxDropDownButtonModule,
  DxFormModule,
  DxHtmlEditorModule,
  DxListModule,
  DxLoadIndicatorModule,
  DxLoadPanelModule,
  DxPopoverModule,
  DxPopupModule,
  DxScrollViewModule,
  DxSelectBoxModule,
  DxTextBoxModule,
  DxToolbarModule,
  DxTooltipModule,
  DxValidatorModule,
} from 'devextreme-angular';
import { HtmlEditorComponent } from './html-editor.component';
import { HtmlEditorFileDirectoryPipe } from './html-editor-file-directory.pipe';
import { HtmlEditorToolbarItemsPipe } from './html-editor-toolbar-items.pipe';
import { HtmlEditorSelectBoxDatasourcePipe } from './html-editor-select-box-data-source.pipe';
import { HtmlEditorVariablesSelectBoxItemsPipe } from './html-editor-variables-select-box-items.pipe';
import { ColorSketchInputModule } from '../color-sketch-input/color-sketch-input.module';
import { AgMediaUploaderModalModule } from '../ag-media-uploader/ag-media-uploader-modal.module';

@NgModule({
  imports: [
    CommonModule,
    DxHtmlEditorModule,
    DxToolbarModule,
    DxScrollViewModule,
    DxButtonModule,
    DxLoadIndicatorModule,
    DxLoadPanelModule,
    DxValidatorModule,
    DxPopupModule,
    DxDropDownButtonModule,
    DxPopoverModule,
    DxSelectBoxModule,
    DxTextBoxModule,
    DxTooltipModule,
    DxFormModule,
    DxListModule,
    ColorSketchInputModule,
    AgMediaUploaderModalModule,
  ],
  declarations: [
    HtmlEditorComponent,
    HtmlEditorFileDirectoryPipe,
    HtmlEditorToolbarItemsPipe,
    HtmlEditorVariablesSelectBoxItemsPipe,

    HtmlEditorSelectBoxDatasourcePipe,
  ],
  exports: [HtmlEditorComponent, HtmlEditorToolbarItemsPipe],
  providers: [],
})
export class HtmlEditorModule {}
